import { makeAutoObservable } from "mobx";

export class PullOptionsState {
  startCell = 'A1';
  createExcelTable = true;
  createDropDowns = true;

  constructor() {
    makeAutoObservable(this);
  }
}
